/* eslint-disable no-console */
import { IAutocompleteField } from 'types/shared';
import {
  KontentDeliveryTaxonomyDTO,
  KontentDeliveryTaxonomyTerm,
  KontentItemsTaxonomySearch,
} from 'utils/restApplicationClient';

/**
 *  Returns a list of taxonomies eligible for display in DraggableAutocomplete component
 *
 * @param taxonomies - List of Kentico taxonomies
 *
 * @param parents - Parent taxonomy name
 *
 * @returns {Array<IAutocompleteField>} - Array of IAutocompleteFields
 */
export const parseTaxonomies = (
  taxonomies: Array<KontentDeliveryTaxonomyDTO | KontentDeliveryTaxonomyTerm>,
  parents: Array<KontentDeliveryTaxonomyDTO | KontentDeliveryTaxonomyTerm> | undefined,
  list: Array<IAutocompleteField> | undefined,
): Array<IAutocompleteField> => {
  const taxonomyList: Array<IAutocompleteField> = list || [];

  taxonomies.forEach((taxonomy) => {
    const { name, codeName, terms } = taxonomy;

    const parentsList = parents ? [...parents] : [];

    parentsList.push(taxonomy);

    if (parents) {
      taxonomyList.push({ label: name, value: codeName, taxonomies: parentsList });
    }

    if (terms) {
      parseTaxonomies(terms, parentsList, taxonomyList);
    }
  });

  return taxonomyList;
};

// eslint-disable-next-line require-jsdoc
const compareArrays = (arrayA: Array<unknown>, arrayB: Array<unknown>): boolean => {
  if (arrayA.length !== arrayB.length) {
    return false;
  }
  return arrayA.reduce((previous: boolean, current, index) => {
    return previous && current === arrayB[index];
  }, true);
};

/**
 * Returns a list of taxonomies elligible for filter request
 *
 * @param taxonomies - List of selected taxonomies
 *
 * @returns An array of parsed taxonomies to be sent to BE
 */
export const parseTaxonomiesFilter = (taxonomies: Array<IAutocompleteField>): Array<KontentItemsTaxonomySearch> => {
  const taxonomyMap: Array<KontentItemsTaxonomySearch> = [];

  taxonomies.forEach(({ taxonomies }) => {
    if (!taxonomies) {
      return;
    }

    const { taxonomyGroupKeys } = taxonomies[0] as KontentDeliveryTaxonomyDTO;
    const term = taxonomies[taxonomies.length - 1].codeName;

    const index = taxonomyMap.findIndex((taxonomy) => compareArrays(taxonomy.taxonomyGroupKeys, taxonomyGroupKeys));

    if (index >= 0) {
      taxonomyMap[index].taxonomyTerms.push(term);
    } else {
      taxonomyMap.push({ taxonomyGroupKeys, taxonomyTerms: [term] });
    }
  });

  return taxonomyMap;
};
